import { useMemo } from 'react';

import { Color } from '@ravago/shared/page-data/models/elements';

interface Props {
   colors: Color[] | undefined;
   colorName: string | undefined;
   producerColorCode: string | undefined;
}

export const useRequestForQuotationColor = ({ colors, colorName, producerColorCode }: Props) =>
   useMemo(() => {
      if (!colors || !colorName) return undefined;
      const selectedColorDetails = colors.find((c) => c.name === colorName) ?? colors.find((c) => c.defaultColor);
      if (!selectedColorDetails) return undefined;

      const selectedColorId = selectedColorDetails.id;
      const selectedColorName = selectedColorDetails.name;
      const selectedColorProducerColorCode = producerColorCode
         ? selectedColorDetails.producerColorCodes.find((cc) => cc.colorCode === producerColorCode)?.colorCode
         : undefined;

      return {
         id: selectedColorId,
         colorName: selectedColorName,
         producerColorCode: selectedColorProducerColorCode
      };
   }, [colors, colorName, producerColorCode]);
